/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const DecisionTable = lazyLoad(
  () => import('./index'),
  module => {
    return module.DecisionTables;
  },
);
